import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthorizationGuard } from './guards/authorization.guard';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./pages/login-container/login-container.module').then(m => m.LoginContainerModule)
  },
  {
    path: '',
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/principal/principal.module').then(m => m.PrincipalModule),
        canActivate: [AuthorizationGuard]
      }
    ]
  }, 
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
